module.exports = __webpack_public_path__ + "img/unpublish.7339f1a8.svg";